'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './member.routes.js';
import MemberListCtrl from './list/list.controller.js';
import MemberViewCtrl from './view/view.controller.js';
import MemPersonalCtrl from './view/personal/personal.controller.js';
import MemAtrCtrl from './view/attributes/attributes.controller.js';
import MemContactCtrl from './view/contact/contact.controller.js';
import MemberFormCtrl from './form/form.controller.js';
import MemberModalSvc from './modal/memberModal.service.js';
import MemModalDeactivateSvc
  from './modalDeactivate/memModalDeactivate.service.js';
import MemModalReactivateSvc
  from './modalReactivate/memModalReactivate.service.js';

export default angular.module('georgeApp.member',
  [uiRouter])
  .config(routing)
  .controller('MemberListCtrl', MemberListCtrl)
  .controller('MemberViewCtrl', MemberViewCtrl)
  .controller('MemPersonalCtrl', MemPersonalCtrl)
  .controller('MemAtrCtrl', MemAtrCtrl)
  .controller('MemContactCtrl', MemContactCtrl)
  .controller('MemberFormCtrl', MemberFormCtrl)
  .factory('MemberModalSvc', MemberModalSvc)
  .factory('MemModalDeactivateSvc', MemModalDeactivateSvc)
  .factory('MemModalReactivateSvc', MemModalReactivateSvc)
  .name;
